/**
 * Pre-production environment configuration.
 *
 * Backend: NestJS running on localhost:3000 (NODE_ENV=pre-prod)
 * Hospital: Hospital Mental  (HMRS)
 * API key: matches HOSPITAL_HMRS_PREPROD_API_KEY in backend .env.pre-prod
 *
 * All backend responses are wrapped by TransformInterceptor:
 *   { success: boolean, data: T, timestamp: string }
 * The ApiResponseInterceptor in this app unwraps the `data` field automatically.
 */
export const environment = {
  name: 'pre-prod',
  production: false,

  /** Base URL of the pre-production NestJS backend */
  apiUrl: 'https://rda-api-pre-production.dagcomunicaciones.com.co/api',
  //apiUrl: 'https://pure-luck-pre-production.up.railway.app/api',

  /**
   * X-API-Key sent on every request.
   * Must match HOSPITAL_HMRS_PREPROD_API_KEY in backend .env.pre-prod.
   *
   * 🏥 Hospital: Hospital Mental  (HMRS)
   * 🔐 Environment: Pre-producción
   * 📅 Generated: Mayo 7, 2026<span class="required-asterisk">*</span>
   *
   * ⚠️  IMPORTANT: This API Key is specific to pre-prod environment
   */
  apiKey: '8597919b0e30b4546e27eff9910b249d50ff5862d90989ff647114457ca1c614',

  /**
   * Shared AES-256 key (64 hex chars) to decrypt the `d` URL parameter from the
   * external app (VBA). Must match the key embedded in the VBA routine.
   */
  urlCryptoKey: '407a24f51a9e3f71cb337163ef466f945abb40601572d8f136e061a6b9c1bc85',

  /**
   * Hospital metadata
   */
  hospital: {
    id: 'HMRS',
    name: 'Hospital Mental ',
    fullName: 'Hospital Mental ',
    code: 'HMRS',
    environment: 'pre-prod' as const,
  },

  /**
   * Feature flag: multi-tenant domain map.
   *
   * - `true`  → Detecta el hospital automáticamente según el dominio
   *             (tenant-config.service.ts usa `tenantMap` por hostname).
   * - `false` → Ignora el mapa de dominios y usa directamente
   *             `apiUrl`, `apiKey` y `hospital` definidos arriba.
   */
  useTenantMap: false,
};
